<template>
<div class="chapter">
<div class="inner_page">
<div style="text-align:right;margin-left:8em">
<p class="h2p" id="ch03"><a id="page_1"></a><a href="#/xhtml/Contents#c03"><b>1</b></a></p>
<p class="h2p1"><a href="#/xhtml/Contents#c03"><b>An Alternative Theory of Urban Politics</b></a></p>
<p class="image1"><img alt="Images" height="4" src="images/line.jpg" width="232"/><a id="page_2"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?eb281bfe